var React = require('react');

function Google (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"fill":"#2A84FC","d":"M21.579 12.234c0-.677-.055-1.359-.172-2.025h-9.403v3.839h5.384a4.614 4.614 0 01-1.992 3.029v2.49h3.212c1.887-1.735 2.97-4.3 2.97-7.333z","key":0}),React.createElement("path",{"fill":"#00AC47","d":"M12.004 21.974c2.688 0 4.956-.882 6.608-2.406l-3.213-2.491c-.894.608-2.047.952-3.392.952-2.6 0-4.806-1.754-5.597-4.113H3.095v2.568a9.97 9.97 0 008.909 5.49z","key":1}),React.createElement("path",{"fill":"#FFBA00","d":"M6.407 13.916a5.971 5.971 0 010-3.817V7.53H3.095a9.977 9.977 0 000 8.953l3.312-2.568z","key":2}),React.createElement("path",{"fill":"#FC2C25","d":"M12.004 5.982a5.417 5.417 0 013.824 1.494l2.846-2.846a9.581 9.581 0 00-6.67-2.593A9.967 9.967 0 003.095 7.53l3.312 2.57c.787-2.363 2.996-4.117 5.597-4.117z","key":3})]));
}

Google.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Google;

Google.default = Google;
